// Global display settings
// Prices are shown. They were hidden while payment happened offline at the
// fridge; that stopped being defensible once the site started taking money,
// since a customer would otherwise build a basket blind and first meet a
// figure on the payment page.
export const SHOW_PRICES = true;

// TWINT QR codes par catégorie (frigo Metio) — prix fixes par catégorie
export const TWINT_QR = {
  plats: { price: 13.9, img: '/qr/twint-plats.png', label: { fr: 'Plats', en: 'Meals' } },
  entrees: { price: 7.5, img: '/qr/twint-entrees.png', label: { fr: 'Entrées & apéro', en: 'Starters & apéro' } },
  desserts: { price: 3.5, img: '/qr/twint-desserts.png', label: { fr: 'Desserts', en: 'Desserts' } },
  boissons: { price: 3.0, img: '/qr/twint-boissons.png', label: { fr: 'Boissons', en: 'Drinks' } },
};

export default { SHOW_PRICES, TWINT_QR };
